import { useState, useEffect } from 'react';

export const useResponsiveDevice = () => {
    const [isMobile, setIsMobile] = useState(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 780px)');

        function handleWindowSize(e: any) {
            if (e.matches) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
        mediaQuery.addListener(handleWindowSize);
        handleWindowSize(mediaQuery);

        return () => mediaQuery.removeListener(handleWindowSize);
    }, []);

    return {
        isMobile,
    };
};
